import React, { useState } from 'react';
import { LocationIcon, BedIcon, BathIcon, AreaIcon, HeartIcon, CheckIcon, ChevronLeftIcon, ChevronRightIcon } from '../Icons/Icons';
import LazyImage from '../LazyImage/LazyImage';
import './PropertyCard.css';

function PropertyCard({ property }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) =>
      prev === property.images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) =>
      prev === 0 ? property.images.length - 1 : prev - 1
    );
  };

  const goToImage = (e, index) => {
    e.stopPropagation();
    setCurrentImageIndex(index);
  };

  const handleCardClick = () => {
    if (window.navigateTo) {
      window.navigateTo('detail');
    }
  };

  return (
    <div className="property-card-listing" onClick={handleCardClick}>
      <div className="property-card-image-container">
        <div className="image-carousel">
          <LazyImage
            src={property.images[currentImageIndex]}
            alt={property.title}
            className="property-card-image"
            aspectRatio="4/3"
          />

          {property.images.length > 1 && (
            <>
              <button className="property-card-carousel-btn prev" onClick={prevImage} aria-label="Previous image">
                <ChevronLeftIcon size={20} color="white" />
              </button>
              <button className="property-card-carousel-btn next" onClick={nextImage} aria-label="Next image">
                <ChevronRightIcon size={20} color="white" />
              </button>
              <div className="property-card-carousel-indicators">
                {property.images.map((_, index) => (
                  <button
                    key={index}
                    className={`property-card-indicator ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={(e) => goToImage(e, index)}
                    aria-label={`Go to image ${index + 1}`}
                  />
                ))}
              </div>
            </>
          )}
        </div>

        {property.featured && (
          <div className="property-badge-featured">Featured</div>
        )}

        {property.verified && (
          <div className="property-badge-verified">
            <CheckIcon size={14} color="white" />
            <span>Verified</span>
          </div>
        )}
      </div>

      <div className="property-card-content">
        <div className="property-card-header">
          <div className="property-price">{property.price}</div>
          {property.pricePerSqft && (
            <div className="property-price-per-sqft">{property.pricePerSqft}</div>
          )}
        </div>

        <h3 className="property-title">{property.title}</h3>

        <div className="property-location">
          <LocationIcon size={16} color="var(--color-text-tertiary)" />
          <span>{property.location}</span>
        </div>

        <div className="property-attributes">
          <div className="attribute">
            <BedIcon size={18} color="var(--color-text-secondary)" />
            <span>{property.beds} Beds</span>
          </div>
          <div className="attribute">
            <BathIcon size={18} color="var(--color-text-secondary)" />
            <span>{property.baths} Baths</span>
          </div>
          <div className="attribute">
            <AreaIcon size={18} color="var(--color-text-secondary)" />
            <span>{property.area}</span>
          </div>
        </div>

        <div className="property-card-footer">
          <div className="property-meta">
            <span className="property-type">{property.type}</span>
            <span className="property-posted">{property.postedDate}</span>
          </div>

          <div className="property-actions">
            <button className="btn-action btn-favorite" aria-label="Add to favorites">
              <HeartIcon size={18} />
            </button>
            <button className="btn-action btn-contact">Contact</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PropertyCard;
